import utilities from "../Resources/Utils";

export class SurveyService {
    static submitSurvey = (form: { value: string }) => utilities.request({
        url: 'Surveys',
        method: 'POST',
        data: form
    })
}